import ApiService from "services/ApiService";
import Helpers from "./Helpers";

class InvoiceHelpers {
  search(companyId, fromDate, toDate) {
    const url = `/api/v1/invoices/search?companyId=${companyId}&issueDateFrom=${Helpers.formatDateToInvoice(
      fromDate
    )}&issueDateTo=${Helpers.formatDateToInvoice(toDate)}`;
    return ApiService.getData(url);
  }
}

export default new InvoiceHelpers();
